import { default as ReleaseBeneficiariesCard } from "./BeneficiariesCard";
import DeprecatedBeneficiariesCard from "./DeprecatedBeneficiariesCard";
import { isFlagEnabled } from "js/utilities";

export default function BeneficiariesCard({ policyDetail }) {
  return isFlagEnabled("ENABLE_NO_BENEFICIARIES") ? (
    <ReleaseBeneficiariesCard policyDetail={policyDetail} />
  ) : (
    <DeprecatedBeneficiariesCard policyDetail={policyDetail} />
  );
}
